import {Props} from '@peachy/utility-kit-pure'
import {Payment, PaymentAttempt} from '../../../../domain/models/Payment'
import {AnEvent} from '../../../event-kit'

export class PaymentReceived extends AnEvent {
    public accountId: string
    public subscriptionId: string
    public paymentInfo: Payment
    public paymentAttempt: PaymentAttempt

    constructor(from: Props<PaymentReceived>) {
        super()
        Object.assign(this, from)
    }
}
